module.exports = __webpack_public_path__ + "static/media/roboto-mono-v5-latin-300italic.18357dda.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/roboto-mono/roboto-mono-v5-latin-300italic.woff2
// module id = 485
// module chunks = 0